<div class="surface-card">
  <div class="surface-card-header surface-card-header-split">
    <span>{{ 'notes.title' | translate }}</span>
    <sh-button
      *ngIf="allowAdd"
      variant="outlined"
      size="sm"
      icon="fa-regular fa-plus"
      label="shared.terms.add"
      (click)="add()"
    ></sh-button>
  </div>
  <sh-table
    tableId="notes"
    density="compact"
    [columns]="columns"
    [rows]="notes"
    [loading]="loading"
    [rowActions]="rowActions"
    [rowOpenMode]="allowEdit ? 'navigate' : 'none'"
    (rowOpen)="onRowOpen($event)"
  >
    <ng-template shCell="description" let-note>
      <i *ngIf="note.pinned" class="fa-solid fa-thumbtack mr-2"></i>
      <b>{{ note.description }}</b>
    </ng-template>
    <ng-template shEmpty>
      <div class="table-empty">{{ 'notes.noFound' | translate }}</div>
    </ng-template>
  </sh-table>
</div>
